import { GetAllCustomersInDto, GetAllCustomersOutDto } from '../../../types/customer.dto'

export const GET_ALL_CUSTOMERS = 'GET_ALL_CUSTOMERS'
export const GET_ALL_CUSTOMERS_SUCCESS = 'GET_ALL_CUSTOMERS_SUCCESS'
export const GET_ALL_CUSTOMERS_ERROR = 'GET_ALL_CUSTOMERS_ERROR'
export const RESET_GET_ALL_CUSTOMERS = 'RESET_GET_ALL_CUSTOMERS'

export interface GetAllCustomers {
  type: typeof GET_ALL_CUSTOMERS
  payload: GetAllCustomersOutDto
}

export interface GetAllCustomersSuccess {
  type: typeof GET_ALL_CUSTOMERS_SUCCESS
  payload: GetAllCustomersInDto
}

export interface GetAllCustomersError {
  type: typeof GET_ALL_CUSTOMERS_ERROR
  payload: string | boolean
}

export interface ResetGetAllCustomers {
  type: typeof RESET_GET_ALL_CUSTOMERS
  payload: null
}

export interface State {
  data: GetAllCustomersInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetAllCustomers | GetAllCustomersSuccess | GetAllCustomersError | ResetGetAllCustomers
